<script lang="ts">
  import { cn } from '../../lib/utils/cn';
  import type { ToastMessage, ToastVariant } from './toast-types.js';

  interface Props {
    messages?: ToastMessage[];
    ondismiss?: (id: string) => void;
  }

  let { messages = [], ondismiss }: Props = $props();

  const variantClasses: Record<ToastVariant, string> = {
    default: 'border-[var(--tx42-panel-border-subtle)] bg-tx42-panel text-tx42-text',
    success: 'border-[#9bc4ad] bg-[#d8eadf] text-[#1a5c38]',
    warning: 'border-[#d4a574] bg-[#f5e6c8] text-[#7c4a03]',
    destructive: 'border-[#c97a7a] bg-[#f3d9d4] text-[#8b1f1f]',
  };
</script>

<div
  class="fixed bottom-4 right-4 z-[60] flex max-w-sm flex-col gap-2"
  role="region"
  aria-label="Notifications"
>
  {#each messages as message (message.id)}
    <div
      class={cn(
        'rounded-[var(--tx42-radius-lg)] border px-4 py-3 shadow-tx42-panel',
        variantClasses[message.variant ?? 'default'],
      )}
      role="status"
      aria-live="polite"
    >
      <div class="flex items-start justify-between gap-3">
        <div>
          <p class="font-semibold">{message.title}</p>
          {#if message.description}
            <p class={cn(
              'mt-1 text-sm',
              message.variant === 'success' ? 'text-[#1a5c38]' : 'text-tx42-text-muted',
            )}>{message.description}</p>
          {/if}
        </div>
        <button
          type="button"
          class="tx42-interactive rounded px-2 py-1 text-xs font-semibold text-tx42-text-muted"
          aria-label="Dismiss notification"
          onclick={() => ondismiss?.(message.id)}
        >
          ×
        </button>
      </div>
    </div>
  {/each}
</div>
